export type SizeKey = "lg" | "md" | "sm";
type SizeType = Record<SizeKey, { height: number; value: SizeKey; width: number }>;

/* eslint-disable sort-keys */
// because of render order in `Size` and `Theme`
export const Size: SizeType = {
  sm: { height: 77, value: "sm", width: 64 },
  md: { height: 115, value: "md", width: 96 },
  lg: { height: 173, value: "lg", width: 144 },
};

/* eslint-disable no-shadow */
// link:https://github.com/typescript-eslint/tslint-to-eslint-config/issues/856
export enum Theme {
  light = "light",
  dark = "dark",
}
/* eslint-enable no-shadow */
/* eslint-enable sort-keys */
